module.exports = __webpack_public_path__ + "img/maintenance-mobile.8a776e62.jpg";